import React, { FC } from 'react';
import { PredefinedPresetName } from '../../../../types';
import { ResizeAndCropOptionField } from './ResizeAndCropOptionField';

export interface PredefinedPresetProps {
  label: string,
  name: PredefinedPresetName,
}

export const PredefinedPreset: FC<PredefinedPresetProps> = ({ label, name }) => {
  return (
    <ResizeAndCropOptionField
      label={label}
      optionPath={`selectedPresets.${name}`}
    />
  );
};
